<template>
  <div>
    <el-row>
      <el-col :span="24">
        <div class="grid-content">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>工作量模块</el-breadcrumb-item>
            <el-breadcrumb-item>工作量汇总</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
      </el-col>
    </el-row>
    <el-row :gutter="20"
            class="grid-content">
      <el-col :span="8">
        <div class="grid-content">
          时间：
          <el-date-picker v-model="moment"
                          type="daterange"
                          style="width: 220px;"
                          range-separator="至"
                          start-placeholder="开始日期"
                          end-placeholder="结束日期"></el-date-picker>
        </div>
      </el-col>
      <el-col :span="8">
        <div class="grid-content">
          员工:
          <el-select v-model="userId"
                     clearable
                     filterable
                     placeholder="请选择员工">
            <el-option v-for="item in userList"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value"></el-option>
          </el-select>
        </div>
      </el-col>
      <el-col :span="8">
        <div class="grid-content">
          批次:
          <el-select v-model="batchId"
                     clearable
                     filterable
                     placeholder="请选择批次">
            <el-option v-for="item in batchList"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value"></el-option>
          </el-select>
        </div>
      </el-col>
    </el-row>
    <div class="inputDiv">
      <el-button type="primary"
                 size="medium"
                 @click="search">查询</el-button>
      <!-- <el-button type="primary" size="medium" @click="add">新增</el-button> -->
      <el-button type="primary"
                 size="medium"
                 @click="salaryExports">导出</el-button>
    </div>
    <el-table :data="tableData"
              border
              style="width: 95%">
      <el-table-column prop="staffName"
                       label="员工名称"
                       width="180"></el-table-column>
      <el-table-column prop="tel"
                       label="员工电话"
                       width="120"></el-table-column>
      <el-table-column prop="batchName"
                       label="批次名称"
                       width="180"></el-table-column>
      <el-table-column prop="processName"
                       label="工序名称"></el-table-column>
      <el-table-column prop="unitSalary"
                       label="工序单价"
                       width="80"></el-table-column>
      <el-table-column prop="amount"
                       label="完成件数"
                       width="80"></el-table-column>
      <el-table-column prop="salary"
                       label="提成(元)"
                       width="100"></el-table-column>
    </el-table>
    <el-pagination class="grid-content"
                   background
                   @current-change="handleCurrentChange"
                   layout="total, prev, pager, next"
                   :total="totalCount"
                   :page-size="pageSize"
                   :page-count="pageTotal"></el-pagination>
  </div>
</template>
<script>
import { batchSel } from "@/api/batch";
import { userSel } from "@/api/uesr";
import { getLast } from "@/util/time";
import moment from "moment";
import {
  workRecordSelUserWorkSta,
  workRecordExpUserWorkSta
} from "@/api/workRecord";
export default {
  data () {
    return {
      userList: [],
      userId: "",
      batchList: [],
      batchId: "",
      moment: getLast(new Date()),
      totalCount: 0,
      pageSize: 10,
      pageNum: 1,
      pageTotal: 0,
      tableData: []
    };
  },
  mounted () {
    this.getBatch(1);
    this.getUser(1);
    this.selUserWorkStaList();
  },
  methods: {
    handleCurrentChange (e) {
      this.pageNum = e;
      this.selUserWorkStaList();
    },
    search () {
      this.handleCurrentChange(1);
    },
    selUserWorkStaList () {
      console.log(this.moment);

      const params = {
        userId: this.userId,
        batchId: this.batchId,
        pageNum: this.pageNum,
        pageSize: this.pageSize
      };
      if (this.moment) {
        params.beginTime = moment(new Date(this.moment[0])).format(
          "YYYY-MM-DD"
        );
        params.endTime = moment(new Date(this.moment[1])).format("YYYY-MM-DD");
      }
      workRecordSelUserWorkSta(params)
        .then(res => {
          this.totalCount = res.page.total_count;
          this.pageTotal = res.page.page_total;
          this.tableData = res.gridData;
        })
        .catch(err => {
          console.log(err);
        });
    },

    getBatch (pageNum) {
      const params = {
        enterpriseId: localStorage.getItem("company_id"),
        username: localStorage.getItem("user_name"),
        pageNum: pageNum,
        pageSize: 100
      };

      batchSel(params)
        .then(res => {
          res.gridData.forEach(element => {
            var batch = {
              value: element.id,
              label: element.title
            };
            this.batchList.push(batch);
          });
          if (pageNum < res.page.page_total) {
            this.getBatch(pageNum + 1);
          }
        })
        .catch(err => {
          console.log(err);
        });
    },

    getUser (pageNum) {
      const params = {
        enterpriseId: localStorage.getItem("company_id"),
        pageNum: pageNum,
        pageSize: 100
      };

      userSel(params)
        .then(res => {
          res.gridData.forEach(element => {
            var user = {
              value: element.id,
              label: element.name
            };
            this.userList.push(user);
          });
          if (pageNum < res.page.page_total) {
            this.getUser(pageNum + 1);
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    salaryExports () {
      const params = {
        userId: this.userId,
        batchId: this.batchId
      };
      var name = "工作汇总";
      if (this.moment) {
        params.beginTime = moment(new Date(this.moment[0])).format(
          "YYYY-MM-DD"
        );
        params.endTime = moment(new Date(this.moment[1])).format("YYYY-MM-DD");
        name = params.beginTime + "-" + params.endTime + "(工作汇总)";
      }

      workRecordExpUserWorkSta(params, name);
    }
  }
};
</script>
